import React from 'react';

interface Props {
  fieldUpdates: Record<string, any>;
  resolvedLabels: Record<string, string>;
}

const ItemEntryTable = ({ fieldUpdates, resolvedLabels }: Props) => {
  const prefix = fieldUpdates['sales_item_entries.items.name']
    ? 'sales_item_entries'
    : fieldUpdates['purchase_item_entries.items.name']
      ? 'purchase_item_entries'
      : null;

  if (!prefix) return null;

  const names = fieldUpdates[`${prefix}.items.name`];
  const quantities = fieldUpdates[`${prefix}.quantity`];
  const rates = fieldUpdates[`${prefix}.rate`];
  const discountAmounts = fieldUpdates[`${prefix}.discount_amount`];
  const taxAmounts = fieldUpdates[`${prefix}.tax_amount`];
  const totalAmounts = fieldUpdates[`${prefix}.total_amount`];

  if (!Array.isArray(names) || names.length === 0) return null;

  const rows = names.map((_: any, i: number) => {
    const itemId = names[i];
    const qty = parseFloat(quantities?.[i]) || 0;
    const rate = parseFloat(rates?.[i]) || 0;
    const gross = qty * rate;
    const discount = parseFloat(discountAmounts?.[i]) || 0;
    const tax = parseFloat(taxAmounts?.[i]) || 0;
    const total = parseFloat(totalAmounts?.[i]) || 0;
    const resolvedKey = `${prefix}.items.name:${itemId}`;
    const itemName = resolvedLabels[resolvedKey] || `Item #${itemId}`;
    return { itemName, qty, rate, gross, discount, tax, total };
  });

  const subtotal = rows.reduce((sum, r) => sum + r.gross, 0);
  const totalDiscount = rows.reduce((sum, r) => sum + r.discount, 0);
  const totalTax = rows.reduce((sum, r) => sum + r.tax, 0);
  const totalDue = rows.reduce((sum, r) => sum + r.total, 0);

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <div className="chatBot--preview-li" style={{ gridTemplateColumns: '1fr repeat(6, 85px)' }}>
          <div className="chatBot--preview-li-h">Item</div>
          <div className="chatBot--preview-li-h right">Qty</div>
          <div className="chatBot--preview-li-h right">Rate</div>
          <div className="chatBot--preview-li-h right">Gross</div>
          <div className="chatBot--preview-li-h right">Discount</div>
          <div className="chatBot--preview-li-h right">Tax</div>
          <div className="chatBot--preview-li-h right">Total</div>
          {rows.map((r, i) => (
            <React.Fragment key={i}>
              <div className="chatBot--preview-li-c">{r.itemName}</div>
              <div className="chatBot--preview-li-c right">{r.qty}</div>
              <div className="chatBot--preview-li-c right">{r.rate.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.gross.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.discount.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.tax.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.total.toFixed(2)}</div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="chatBot--preview-tot">
        <div className="chatBot--preview-tot-row">
          <span>Subtotal</span>
          <span className="chatBot--preview-tot-row-val">{subtotal.toFixed(2)}</span>
        </div>
        {totalDiscount > 0 && (
          <div className="chatBot--preview-tot-row">
            <span>Discount</span>
            <span className="chatBot--preview-tot-row-val">-{totalDiscount.toFixed(2)}</span>
          </div>
        )}
        {rows.filter(r => r.tax).map((r, i) => (
          <div className="chatBot--preview-tot-row" key={i}>
            <span>Tax</span>
            <span className="chatBot--preview-tot-row-val">{r.tax.toFixed(2)}</span>
          </div>
        ))}
        <div className="chatBot--preview-tot-row total">
          <span>Total due (items)</span>
          <span className="chatBot--preview-tot-row-val">{totalDue.toFixed(2)}</span>
        </div>
      </div>
    </>
  );
};

export default ItemEntryTable;
